const organisations = {
	title: "Organisasjoner",
	title_s: "Organisasjon",
	new_organisation: "Ny organisasjon",
	edit_organisation: "Rediger organisasjon: {name}",
	view_organisation: "Vis organisasjon: {name}",
	list_title: "Organisasjoner",
	list_subtitle: "Håndtere organisasjoner",
	create_title: "Opprett organisasjon",
	update_title: "Endre organisasjon",
	details_title: "Organisasjonsdetaljer",
	visiting_address_title: "Besøksadresse",
	invoice_address_title: "Faktura adresse",
	invoice_title: "Faktura detaljer",
	id: "ID",
	name: "Navn",
	email: "Epost",
	vat: "Orgnr",
	code: "Organisasjonskode",
	phone: "Telefon",
	owner: "Systemeier",
	po_number: "PO",
	invoice_ref: "Referanse",
	email_invoice: "Faktura epost",
	same_as_visiting: "Samme som besøks adresse",
	certification_authority: "Sertifiseringsorgan for XL3",
	certification_authority_short: "Sert. org. for XL3",
	certification_authority_123service: "Sertifiseringsorgan XL3",
	certification_authority_123service_short: "Sert. org. for XL3",
	certification_company_id: "Sertifiseringsorgan",
	member_organisation: "Medlemsorganisasjon",
	member_organisation_short: "Medl.org.",
	certification_agencies: "Sertifiseringsorgan",
	certification_agencies_by: "Sertifisert",
	course_type_groups: "Tillate kursgrupper",
	course_types: "Tillate kurstyper",
	customergroups: "Kundegruppe",
	member_of: "Medlem av",
	course_types_and_group: "Kursgrupper og typer",
	visiting_street: "Adresse",
	visiting_city: "Sted",
	visiting_state: "Fylke",
	visiting_zip: "Postnr",
	visiting_country: "Land",
	invoice_street: "Adresse",
	invoice_city: "Sted",
	invoice_state: "Fylke",
	invoice_zip: "Postnr",
	invoice_country: "Land",
	logo: "Logo",
	member_logo: "Medlemslogo",
	upload_image: "Oppdater logo",
	select_image: "Velg logo",
	upload_ml_image: "Oppdater medlemslogo",
	select_ml_image: "Velg medlemslogo",
	update_tenants: "Vil du oppdatere klient(er)?",
	org_active_users: "Aktive brukere",
	no_of_active_users: "Antall aktive",
	no_of_tenants: "Antall klienter",
	org_does_not_exist: "Ingen organisasjon funnet",
	has_active_tenants: "Selskap har aktive klienter. De må deaktiveres/slettes først.",
	vat_does_not_exist: "Orgnr eksisterer ikke.",
	agreement_active_from: "Avtale er aktivt fra",
	agreement_cancelled_from: "Avtalen kansellert fra",
	agreement_responsible: "Avtaleansvarlig",
	internal_note: "Intern notat",
	certification_id: "Sertifiserings-/godkjennings-ID",
};
export default organisations;